import Layout from '@/layout'
export default {
    path: '/queryStatistics',
    component: Layout,
    redirect: '/queryStatistics/scaleTypeAdmin',
    name: 'queryStatistics',
    meta: {
        title: '查询统计',
        icon: 'yewu',
    },
    hidden: false,
    children: [
        {
            path: 'suifangListAdmin',
            component: () => import('@/views/yewuAdmin/suifangListAdmin/index.vue'),
            name: 'suifangListAdmin',
            meta: {
                title: '电话随访记录',
            },
            hidden: false,
        },
        {
            path: 'ziPingLiangBiaoList',
            component: () => import('@/views/yewuAdmin/ziPingLiangBiaoList'),
            name: 'ziPingLiangBiaoList',
            meta: {
                title: '问卷随访记录',
                showfater: true
            },
            hidden: false,
        },
        // {
        //     path: 'followUpRecordVisit',
        //     component: () => import('@/views/followUpRecord/visit'),
        //     name: 'followUpRecordVisit',
        //     meta: {
        //         title: '上门随访记录',
        //         showfater: true
        //     },
        //     hidden: false,
        // },
        {
            path: 'followUpRecordMsg',
            component: () => import('@/views/followUpRecord/msg'),
            name: 'followUpRecordMsg',
            meta: {
                title: '短信记录',
                showfater: true
            },
            hidden: false,
        },
        {
            path: 'foodAdjustRecord',
            component: () => import('@/views/queryStatistics/foodAdjust'),
            name: 'foodAdjustRecord',
            meta: {
                title: '膳食调整记录',
                showfater: true
            },
            hidden: false,
        },
        {
            path: 'medicationAdjustRecord',
            component: () => import('@/views/queryStatistics/medicationAdjust'),
            name: 'medicationAdjustRecord',
            meta: {
                title: '用药调整记录',
                showfater: true
            },
            hidden: false,
        },
        {
            path: 'returnVisitReservationRecord',
            component: () => import('@/views/queryStatistics/returnVisitReservation'),
            name: 'returnVisitReservationRecord',
            meta: {
                title: '复诊预约记录',
                showfater: true
            },
            hidden: false,
        },
        {
            path: 'motionAdjustRecord',
            component: () => import('@/views/queryStatistics/motionAdjust'),
            name: 'motionAdjustRecord',
            meta: {
                title: '运动调整记录',
                showfater: true
            },
            hidden: false,
        },
        {
            path: 'patientStatistics',
            name: 'patientStatistics',
            component: () => import(/** webpackChunkName: "healthWarn" */ '@/views/healthWarning/patientStatistics/index.vue'),
            meta: {
                title: '指标预警记录',
                showfater: true,
            },
            hidden: false,
            children: []
        },
        {
            path: 'scaleCheck',
            component: () => import(/** webpackChunkName: "queryStatistics" */'@/views/yewuAdmin/scaleCheck/index.vue'),
            name: 'scaleCheck',
            meta: {
                title: '评估量表统计',
            },
            hidden: false
        },

        {
            path: 'countList',
            component: () => import(/** webpackChunkName: "queryStatistics" */'@/views/yewuAdmin/countList/index.vue'),
            name: 'countList',
            meta: {
                title: '患者指标趋势',
            },
            hidden: false,
        },
        {
            path: 'indexStatistics',
            name: 'indexStatistics',
            component: () => import(/** webpackChunkName: "healthWarn" */ '@/views/healthWarning/indexStatistics/index.vue'),
            meta: {
                title: '预警指标统计',
                showfater: true,
            },
            hidden: false,
            children: [
                {
                    path: 'indexDetail',
                    name: 'indexDetail',
                    component: () => import(/** webpackChunkName: "healthWarn" */ '@/views/healthWarning/indexDetail/index.vue'),
                    meta: {
                        title: '预警指标明细',
                        activeMenu: '/healthWarning/indexStatistics',
                        showfater: false
                    },
                    hidden: true
                }
            ]
        },

        {
            path: 'indexCheck',
            component: () => import(/** webpackChunkName: "queryStatistics" */ '@/views/yewuAdmin/indexCheck/index.vue'),
            name: 'indexCheck',
            meta: {
                title: '评估指标查看',
            },
            hidden: false,
        },
        // {
        //     path: 'allAnyAccessCheck',
        //     component: () => import('@/views/yewuAdmin/allAnyAccessCheck/index.vue'),
        //     name: 'allAnyAccessCheck',
        //     meta: {
        //         title: '全部评估',
        //         showfater: true,
        //     },
        //     hidden: false,
        //     children: [{
        //         path: 'pingGuD',
        //         component: () => import('@/views/yewuAdmin/pingGuD/pingguD.vue'),
        //         name: 'pingGuD',
        //         meta: {
        //             title: '评估详情',
        //             showfater: false,
        //             activeMenu: '/yewuAdmin/allAnyAccessCheck',
        //         },
        //         hidden: true,
        //     }]
        // },
        {
            path: '/visualizationPanel',
            component: () => import('@/views/yewuAdmin/visualizationPanel/index.vue'),
            name: 'visualizationPanel',
            meta: {
                title: '慢性评估可视化平台',
            },
            hidden: false,
        }, {
            path: 'http://adminfoacc.8218ai.com/index-large-screen.html/login?redirect=/&name=18000000000&password=123456',
            name: 'midGround',
            meta: {
                title: '健康体检可视化平台'
            },
            hidden: false,
        },
    ]
}